module.exports = __webpack_public_path__ + "static/media/pano.f127e057.jpg";